<template>
  <router-link
    :to="path"
    active-class="is--active"
    class="nav-item group flex items-center px-2 py-2 text-sm font-semibold text-gray-600 rounded-md"
    :class="checkRoot()"
    @click.native="$emit('clearSearch', path)"
  >
    <slot />
    {{ label }}
  </router-link>
</template>

<script>
export default {
  props: {
    path: String,
    label: String,
  },
  methods: {
    checkRoot() {
      if (this.$route.path === '/' && this.path === '/partners') {
        return 'is--active';
      }
    },
  },
};
</script>
